import { Common } from '@stockbit/ui';
import { SelectGroup, InputGroup } from '../../styled';
import OptionsGroup from './OptionsGroup';
import useValueMetrics from './useValueMetrics';

const { Flex } = Common;

interface InputMetricsProps {
  disabled?: boolean;
  selectValue: any;
  value: any;
  onChange: (e: any) => void;
  onSelect: (e: any) => void;
}

function InputMetricMultiple({
  disabled,
  selectValue,
  value,
  onChange,
  onSelect,
}: InputMetricsProps) {
  const { metrics, getMetrics } = useValueMetrics();

  const options = metrics?.params?.multiple || {};

  const labelName = {
    year_one: '1 Year',
    year_three: '3 Year',
  };

  return (
    <Flex>
      {metrics.params && (
        <SelectGroup
          // defaultValue={getDefaultValueIndexMetrics('MULTIPLE')}
          value={selectValue === 0 ? getMetrics('multiple') : selectValue}
          onSelect={onSelect}
          style={{ minWidth: '50px' }}
          getPopupContainer={() => document.getElementById('sw-valuation-form')}
        >
          {Object.keys(options).map((i) => {
            const currentMultiple = options[i];
            if (Array.isArray(currentMultiple)) {
              return (
                <SelectGroup.OptGroup label={labelName[i]}>
                  {currentMultiple.map((dataMultiple) => (
                    <OptionsGroup value={dataMultiple.fitem_id}>
                      {dataMultiple.fitem_name}
                    </OptionsGroup>
                  ))}
                </SelectGroup.OptGroup>
              );
            }
            return (
              <OptionsGroup value={currentMultiple.fitem_id}>
                {currentMultiple.fitem_name}
              </OptionsGroup>
            );
          })}
        </SelectGroup>
      )}
      <InputGroup onChange={onChange} disabled={disabled} value={value} />
    </Flex>
  );
}

export default InputMetricMultiple;
